export default __webpack_public_path__ + "static/media/cybertime.07c5de3b.jpg";